import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  padding: 30px;
  overflow: hidden;

  @media (max-width: 1000px) {
    padding: 30px 5px;
  }
`;
